// #############################################################
//                              Imports
// #############################################################
import './components.css';
import MiniPost from './MiniPost';

import postList from '../posts.json';

const PostList = () => {
    return (
        <div className="post-list">
            <h1>Alle Verwijzingen</h1>
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Title</th>
                        <th scope="col">Link</th>
                        <th className="text-center" scope="col">
                            Copy to clipboard
                        </th>
                        <th className="text-center" scope="col">
                            Bekijk Verwijzing
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {postList.length &&
                        postList.map((post, i) => {
                            return <MiniPost key={post.id} post={post} i={i} />;
                        })}
                </tbody>
            </table>
        </div>
    );
};

export default PostList;
